import React from 'react';
import {Card, Grid} from "@material-ui/core";
import {ticketStart} from "../../../assets/images/images";

const productCategories = [
  {text: 'crops & grains', color: '#FBEDE7', icon: ticketStart},
  {text: 'fruits & vegetables', color: '#E9F6E5', icon: ticketStart},
  {text: 'livestock & dairy', color: '#F2E7FC', icon: ticketStart},
  {text: 'fisheries & aquaculture', color: '#E1F5FD', icon: ticketStart},

]

const serviceCategories = [
  {text: 'agri services & inputs', color: '#FDEFD3', icon: ticketStart},
  {text: 'vendor', color: '#rgba(76, 175, 80, 0.15)', icon: ticketStart},
  {text: 'buyer', color: '#F2E7FC', icon: ticketStart},
]

const ordersCategories = [
  {text: 'my orders', color: '#E1F5FD', icon: ticketStart},
  {text: 'order for me', color: '#FBEDE7', icon: ticketStart},
]

function Index(props) {
  const {type = '', active = 'crops & grains',setActive, order} = props;
  return (
    <Grid container lg={12} md={12} className='mt-10 mb-20 full-width ' elevation={0}>
      {(type === 'product' ? productCategories : order ? ordersCategories : serviceCategories).map((item, index) => (
        <Grid item className=' ml-10 mt-10 ' key={index} lg={2} md={2} sm={4} onClick={() => {
          // item.text === 'services' &&
         order&& setActive(item.text)
        }}>
          <Card className='display-flex align-items-center justify-content-between  p-10 ' elevation={0}
                style={{backgroundColor: item.color, color: item.text === active ? 'black' : 'lightblue'}}>
            <h5 className='text-capitalize m-0 '
                style={{color: item.text === active ? 'black' : 'rgba(0, 0, 9, 0.2)'}}>{item.text}</h5>
            <img src={item.icon} className='' style={{width: 20}} alt=''/>
          </Card>
        </Grid>
      ))}
    </Grid>
  );
}

export default Index;
